<template>
  <div class="gw_mesblock">
    <div
      class="gw_mesblock_title"
      v-html="$t(`messages.${userCode}.title_tra01`)"
    />

    <LoaderSpinner
      v-if="loading"
      style="--size: 4rem"
      class="mt-4"
    />

    <div
      v-else
      class="free-options position-relative mt-4"
    >
      <div
        v-for="(group, i) in availableReports"
        :key="i + 'free'"
        class="free-options_column mx-2"
      >
        <ExpandCard
          :opened="i === 0"
          style="--radius: 4px; --content-padding: 1rem"
        >
          <template #title>
            <div
              class="pr-2"
              v-html="getGameformatOptionHtml(group.options[0].gameformat)"
            ></div>
          </template>
          <div class="free-options_column_options">
            <div
              v-for="(item, idx) in group.options"
              :key="`free_${idx}`"
              class="free-options_item mx-auto w-100 mb-1"
            >
              <v-btn
                size="large"
                class="w-100"
                color="var(--clr-blue-1)"
                :data-tst="`reports_free_${item.id}_option`"
                @click="useShortcut(item)"
              >
                <i class="mr-1 mdi mdi-bookmark-outline text-semi-large"></i>
                {{ item.name }}
              </v-btn>
            </div>
          </div>
        </ExpandCard>
      </div>
    </div>

    <div
      class="gw_mesblock_subtitle"
      v-html="
        $t(
          `messages.${
            userCode === 'starterUser403' ? `${userCode}.subtitle_tra01` : `${userCode}.subtitle`
          }`,
        )
      "
    ></div>

    <div class="mt-4 mx-auto">
      <v-btn
        size="large"
        color="primary"
        :to="{
          name: 'SubscriptionOverview',
          query: { gm_type: gameformat.gm_type },
        }"
        data-tst="reports_upgrade_btn"
      >
        <i class="mdi text-large mdi-crown mr-2"></i>
        {{ $t('btn.upgrade') }}
      </v-btn>
    </div>
  </div>
</template>

<script>
import { nextTick } from 'vue'
import LoaderSpinner from '@/components/Loaders/LoaderSpinner'
import ExpandCard from '@/components/Common/ExpandCard/ExpandCard'
import { getGameformatOptionHtml } from '@/store/gameformat/gameformat'
// import turnAvailableFormatsMock from './turnAvailableFormatsMock.json'

export default {
  name: 'ReportsAvailableShortcuts',
  components: {
    // GameFormatOption,
    LoaderSpinner,
    ExpandCard,
  },
  props: {
    namespace: { String, required: true },
    userCode: String,
  },
  created() {
    this.$store.dispatch(this.reportShortcut)
  },
  methods: {
    // http://localhost:8080/solutions?gametype=SpinsGeneral&depth=25&stacks=25-16-25&history_spot=3&soltab=reports&preflop_actions=R2-F-C
    useShortcut(shrt) {
      const { gameformat } = shrt
      this.$store.dispatch('globals_action', 'disable_history_watcher')

      this.$store.dispatch('api_cache_clear')
      setTimeout(() => {
        this.$store.dispatch('router_update_query', {
          query: {
            stacks: gameformat.stacks,
            gametype: gameformat.gametype,
            depth: gameformat.depth,
          },
          push: true,
        })

        const shortcut_id = shrt.id
        this.$store.dispatch('api_history_shortcut', {
          shortcut_id,
          namespace: this.namespace,
          resetReports: true,
        })
      })
    },
    getGameformatOptionHtml(gmf) {
      return getGameformatOptionHtml({ gameformat: gmf })
    },
  },
  computed: {
    reportShortcut() {
      // api_poker_shortcuts_flop
      // api_poker_shortcuts_card
      const param = this.street === 'flop' ? 'flop' : 'card'
      return `api_poker_shortcuts_${param}`
    },
    loading() {
      return this.$store.getters.api_get(this.reportShortcut).loading
    },
    apiData() {
      return this.$store.getters.api_get_data(this.reportShortcut)
    },
    gameformat() {
      return this.$store.getters[`${this.namespace ? `${this.namespace}/` : ''}gameformat`]
    },
    availableReports() {
      const { gameformats } = this.$store.getters
      let res = (this.apiData || []).map(shrt => {
        const gmf = gameformats.find(j => {
          const gm = shrt.gamemode
          const { gametype } = gm
          const depth = Number(gm.depth)
          let stacks = gm.stacks || ''
          if (stacks) {
            stacks = stacks
              .split('-')
              .map(s => Number(s))
              .join('-')
          }

          const r = gametype === j.gametype && depth === j.depth && stacks === j.stacks
          return r
        })
        const name = `${shrt.label.positions.join(' vs. ')} - ${shrt.label.type}`
        const group = gmf?.group
        const r = {
          ...shrt,
          name,
          group,
          gameformat: gmf,
        }
        return r
      })

      const group = this.gameformat?.group
      res = res.filter(i => {
        const r = i.group ? group === i.group : false
        return r
      })

      const ids = [...new Set(res.map(i => i.gameformat.id))]
      res = ids.map(id => {
        const options = res.filter(i => i.gameformat.id === id)
        const { gameformat } = options[0]
        const r = {
          id,
          options,
          gameformat,
        }
        return r
      })

      // console.log(res)
      return res
    },
    street() {
      return this.$store.getters.street
    },
    mobile() {
      return this.$store.getters.mobile
    },
  },
}
</script>

<style lang="scss" scoped>
@media (max-width: 1023px) {
  .message-overlay {
    &_title {
      font-size: 1.5rem !important;
    }
    &_subtitle {
      font-size: 1rem !important;
    }
  }
  .free-options {
    max-height: calc(var(--vh-100) - 32rem) !important;
  }
}
.message-overlay {
  &_text-block {
    text-align: center;
    background: var(--clr-black-0);
    padding: 2rem;
    border-radius: 8px;
    align-self: flex-start;
    display: flex;
    flex-direction: column;
    margin-top: 4rem;
    align-items: center;
    box-shadow: 0 0 4px var(--clr-black-0);
  }
  &_title {
    max-width: 45rem;
    font-size: 2rem;
    margin-bottom: 0.25rem;
    font-weight: 700;
    color: var(--clr-white-0);
    &_small {
      font-size: 1.5rem;
    }
  }
  &_subtitle {
    max-width: 34rem;
    font-size: 1.25rem;
    font-weight: 500;
    color: var(--clr-grey-2);
  }
}

.free-options {
  overflow-x: hidden;
  overflow-y: auto;
  max-height: calc(var(--vh-100) - 44rem);
  position: relative;
  &_column {
    display: flex;
    flex-direction: column;
    margin: 0 0 0.5rem 0;
    &_options {
      display: flex;
      flex-direction: column;
      overflow-x: hidden;
      overflow-y: auto;
    }
    &_cards {
      display: flex;
    }
  }
}
</style>
